import { Directive, ElementRef, Renderer2, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appPreventOutsideClick]',
})
export class PreventOutsideClickDirective implements OnDestroy {
  private preventOutsideClick: any;
  private observer: MutationObserver;
  private isModalOpen = false;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    const dialogElement = this.elementRef.nativeElement;

    // Función para bloquear clics fuera de modales visibles
    this.preventOutsideClick = (event: MouseEvent) => {
      if (!this.isModalOpen) return;

      const target = event.target as HTMLElement;
      const allOpenModals = document.querySelectorAll('.ms-Dialog.is-open');

      // Permitir clics si están dentro del modal más interno visible
      if (Array.from(allOpenModals).some((modal) => modal.contains(target))) {
        return;
      }

      // Bloquear clics fuera de los modales
      event.stopImmediatePropagation();
      event.preventDefault();
    };

    // Escuchar clics globalmente
    document.addEventListener('click', this.preventOutsideClick, true);

    // Configurar observador de mutaciones para rastrear estado del modal
    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.attributeName === 'class') {
          this.isModalOpen = dialogElement.classList.contains('is-open');
        }
      }
    });

    this.observer.observe(dialogElement, { attributes: true });
  }

  ngOnDestroy(): void {
    // Limpiar recursos al destruir la directiva
    document.removeEventListener('click', this.preventOutsideClick, true);
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
  